import { render } from "./copyright.vue?vue&type=template&id=6e9f603c&scoped=true"
import script from "./copyright.vue?vue&type=script&lang=js"
export * from "./copyright.vue?vue&type=script&lang=js"

import "./copyright.vue?vue&type=style&index=0&id=6e9f603c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e9f603c"

export default script